import styled from "styled-components";
import { Utils } from "@tiffin/app-common";
import { Loading, toast } from "@tiffin/components";
import { useAppSelector } from "../../hooks";
import { ReactComponent as StripeBadge} from '../../assets/stripe-badge-blurple.svg';

import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { useEffect, useState } from "react"
import LockFilled from "@ant-design/icons/LockFilled"
import Icon from '@ant-design/icons';
import { Button, Form } from "antd"
import { useIonToast } from "@ionic/react"
import { Browser } from "@capacitor/browser"

interface ICheckoutForm {
  className?: string,
  date: string
  orderId?: string
  amount: number
  loading: boolean
  clientSecret: string,
  tableNumber?: number
}

const StripeBadgeIcon = (props: any) => <Icon onClick={() => Browser.open({ url: "https://stripe.com/" })} component={StripeBadge} {...props} />;

export const CheckoutForm = styled(BaseCheckoutForm)`
  padding: 20px;
  background-color: #fff;

  .checkout-form {
    display: grid;
    gap: 20px;
  }

  .stripe-badge {
    padding: 15px 0px 10px;
    display: flex;
    gap: 5px;
    align-items: center;
    .stripe-icon {
      svg {
        height: 2em;
        width: 10em;
      }
    }
  }

  .tc_privacy_message {
    font-size: x-small;
  }
`

// https://github.com/capacitor-community/stripe/blob/e197e835c897ace806c7564817e3cb79c06f51ed/.docs/pages/usage.md
export function BaseCheckoutForm(props: ICheckoutForm) {
  const stripe = useStripe()
  const elements = useElements()

  const partnerUrlName = useAppSelector((state) => state.store.details?.urlName ? Utils.convertToLowerName(state.store.details?.urlName) : undefined)
  const partnerDemo = useAppSelector((state) => state.store.details?.demo)
  const [processing, setProcessing] = useState<boolean>(false)

  const [present] = useIonToast();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    stripe.retrievePaymentIntent(props.clientSecret).then(({ paymentIntent }) => {
      if(paymentIntent) {
        switch (paymentIntent.status) {
          case "succeeded":
            toast(present, "Payment succeeded!");
            break;
          case "processing":
            toast(present, "Your payment is processing.");
            break;
          case "requires_payment_method":
            break;
          default:
            toast(present, "An unexpected error occurred", "danger");
            break;
        }
      }
    });
  }, [stripe, present, props.clientSecret]);

  async function handleSubmit(event: any) {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    setProcessing(true)

    //Set order to pending payment
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `http://${process.env.REACT_APP_TIFYN_BASE_URL}/${partnerUrlName}/postPayment/${encodeURIComponent(props.date)}?orderId=${props.orderId}${props.tableNumber ? `&table=${props.tableNumber}` : ''}`,
      },
    });

    if (error.type === "card_error" || error.type === "validation_error") {
      if(error.message) toast(present, error.message, "danger");
    } else {
      toast(present, "An unexpected error occurred", "danger")
    }

    setProcessing(false);

  }

  return (
    <div className={props.className}>
      <Form className="checkout-form">
        <PaymentElement id="payment-element" />
        <Button loading={processing} type="primary"  disabled={props.loading || !stripe || !elements || partnerDemo} onClick={handleSubmit}>
          Place order {props.amount > 0 && `• $${(props.amount / 100).toFixed(2)}`}
        </Button>
      </Form>
      <div className="stripe-badge">
        <LockFilled />
        Guranteed safe & secure checkout
        <StripeBadgeIcon className="stripe-icon" />
      </div>
      <span className="tc_privacy_message">By placing an order, you agree to Tifyn's <a href="https://tifyn.com.au/customer-terms-and-conditions.html" target="_blank">Terms and Conditions</a> and <a href="https://tifyn.com.au/privacy-policy.html" target="_blank">Privacy Policy</a>.</span>

      <Loading isOpen={processing} message="Processing Payment" showBox={true} />
    </div>
  )
}